

























import { editFactory } from '@/main/pages';

import { apiProvider as ServiceJobProvider } from '@/modules/servis/serviceJob/api';

import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';

import { showNotification, showAlert } from '@/main/utils/notifications';

import { store } from './store/edit';
import { NAME } from './constants';


export default editFactory(NAME, store).extend({
	data() {
		return {
			isServiceJobNumberChanged: false,
		};
	},
	watch: {
		ServiceJobNumber: {
			immediate: true,
			handler(value: any) {
				if (value === 0 || value === '0') {
					this.ServiceJobNumber = null;
				}
			},
		},
	},
	methods: {
		preventNegativeInput(value: any) {
			// Sanitize input: remove non-digits, prevent negatives and truncate to 9 chars
			if (value === null || value === undefined) {
				this.ServiceJobNumber = null;
				return;
			}
			let s = value.toString();
			// Remove any non-digit characters (this strips '-' too)
			s = s.replace(/\D/g, '');
			// Enforce max length of 9 characters
			if (s.length > 9) s = s.slice(0, 9);
			if (s === '') {
				this.ServiceJobNumber = null;
				return;
			}
			// Preserve leading zeros by saving as string of digits
			this.ServiceJobNumber = s;
		},
		async ChangeServiceJobNumber(ServiceJobNumber: any) {
			// Reject negative values
			if (ServiceJobNumber < 0) {
				this.ServiceJobNumber = null;
				this.isServiceJobNumberChanged = false;
				return;
			}
			if (ServiceJobNumber === null || ServiceJobNumber === 0 || ServiceJobNumber.toString() === '') {
				this.ServiceJobNumber = null;
				this.isServiceJobNumberChanged = false;
				return;
			}
			this.isServiceJobNumberChanged = true;
		},
		async onWorkshopChange(workshopId: number) {
			if (!this.isServiceJobNumberChanged && (this.ServiceJobId <= 0 || this.ServiceJobId === null) && workshopId !== null && workshopId !== 0) {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const response = await ServiceJobProvider.GetNextServiceJobNumber(workshopId);
				this.ServiceJobNumber = response?.data;
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		async saveClick() {
			if (this.ServiceJobNumber === null || this.ServiceJobNumber === 0 || this.ServiceJobNumber.toString() === '') {
				showAlert({
					message: this.LocalizeChyboveHlasky('SERVICE_JOB_REQUIRED'),
					title: 'Notification',
					options: {
						type: 'info',
					},
				});
			} else if ((await ServiceJobProvider.CanServiceJobNumberExist(this.ServiceJobNumber, this.ServiceJobId, this.WorkshopId)).data) {
				showAlert({
					message: this.LocalizeChyboveHlasky('SERVICE_JOB_NUMBER_ALREADY_EXISTS'),
					title: 'Notification',
					options: {
						type: 'info',
					},
				});
			} else {
				await this.save();
			}
		},
	},
});
